import React from "react";
import InventoryStockTable from "../components/Inventory/InventoryStockTable";
import { fetchMenuItems } from "../services/menu.service";
import { getUser } from "../lib/authToken";
import { DEV_USER } from "../config/localAuth";

export default function InventoryStock() {
  const user = getUser() || DEV_USER;
  const ORG_ID = user.restaurant_id;
  const LOCATION = user.location;

  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr(null);
      try {
        const list = await fetchMenuItems({ orgId: ORG_ID, location: LOCATION });
        setItems(list || []);
      } catch (e) {
        setErr(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [ORG_ID, LOCATION]);

  return (
    <div className="page page--inventory-stock">
      <h1>Inventory Stock</h1>
      {err && (
        <div className="error-box">
          <b>Couldn’t load menu items</b>
          <div className="muted">{String(err.message || err)}</div>
        </div>
      )}
      {loading ? (
        <div>Loading...</div>
      ) : (
        <InventoryStockTable items={items} orgId={ORG_ID} location={LOCATION} />
      )}
    </div>
  );
}
